export default __webpack_public_path__ + "static/media/magic.99cf21b5.gif";